import React from 'react';

const RadioBadge = (props) => {
    const checkedValue = props.checkedValue;
    const onChangeFunc = props.onChange;

    return (
        <div className="border-none divide-x divide-slate-200 inlibe-block rounded-3xl mb-2 mx-1.5 overflow-hidden shadow-sm shadow-slate-400 h-6">
            {props.options.map((option) => (
                <span key={`${props.id}_${option.value}`}>
                    <input
                        className="absolute hidden invisible peer"
                        type="radio"
                        id={`${props.id}_${option.value}`}
                        name={`${props.id}_${option.value}`}
                        checked={checkedValue === option.value}
                        value={option.value}
                        onChange={(e) => onChangeFunc(e.target.value)}
                    />
                    <label
                        className="text-sf-primary bg-white font-semibold inline-block cursor-pointer text-sm pb-0.5 pt-0.5 px-3 align-top peer-checked:bg-sf-primary peer-checked:text-white"
                        htmlFor={`${props.id}_${option.value}`}>
                        {option.label}
                    </label>
                </span>
            ))}
        </div>
    );
};

export default RadioBadge;
